var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({position: 'fixed', left: _vm.left+'px', top: _vm.top+'px', width:_vm.width+'px', height: _vm.height+'px', border: 'solid 2px yellow'})})
}
var staticRenderFns = []

export { render, staticRenderFns }